module.exports = "/_next/static/images/RenewableEnergy-7cdffba43dbfa5cd91f30f2e258ee79f.webp";